export function removeFirstForwardSlashFromPath(path: string) {
  return path?.startsWith("/") ? path.split("/")[1] : path
}
